






















































import { Component, Vue, Provide,Prop,Watch } from "vue-property-decorator";
import {  timeFormat ,timeFormatDay} from "@/utils";

const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");


@Component({
    name: "occupancy",
    components: { deleteDialog }
})
export default class CombinationProperty extends Vue {
    @Prop() occupancyAdd: any;
    @Prop() occupancyDetail: any;
    @Prop() detailInfo: any;
    @Prop() occupancyLoading:any;

    // @Provide() private addNewInfo: Boolean = true;//是否显示
    // @Provide() private showAdd: Boolean = false;//是否显示
    @Provide() private dialogVisible: Boolean = false;
    @Provide() private detailForm: any = {};
    @Provide() private type: any = 'add';


    //工作经历
    @Provide() private occupancyForm: any = {
        listList:[],
        panelstatus:0,
    };

    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            // 只要有变化就重新赋值，且进行深拷贝，不影响其他值
            let list = this.detailInfo.occupancy.listList
            for(let i = 0 ; i < list.length; i++){
                let begintime = list[i].begintime == 0 ? '' : String(list[i].begintime)
                let endtime = list[i].endtime == 0 ? '' : String(list[i].endtime)
                if(begintime && endtime){
                    list[i].companyTime = []
                    list[i].companyDate = begintime.slice(0,4) + '-' + begintime.slice(4,6) + '-' + begintime.slice(6,8) + '——' + endtime.slice(0,4) + '-' + endtime.slice(4,6) + '-' + endtime.slice(6,8)
                    list[i].companyTime[0] = begintime.slice(0,4) + '-' + begintime.slice(4,6) + '-' + begintime.slice(6,8)
                    list[i].companyTime[1] = endtime.slice(0,4) + '-' + endtime.slice(4,6) + '-' + endtime.slice(6,8)

                }else{
                    list[i].companyDate = ''
                    list[i].companyTime = []
                }
            }
            this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.occupancy))
            this.occupancyForm = JSON.parse(JSON.stringify(this.detailInfo.occupancy))
            this.$emit('initForm',this.occupancyForm,'5')
        }
    }

    private created () {
        this.$emit('initForm',this.occupancyForm,'5')
    }
    private dateChange (val:any) {
        this.$forceUpdate()
    }   
    // submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                let list = this.occupancyForm.listList
                for(let i = 0 ; i < list.length ; i++){
                    if(list[i].companyTime && list[i].companyTime.length>0){
                        list[i].begintime = Number(list[i].companyTime[0].replace(/-/g,''))
                        list[i].endtime = Number(list[i].companyTime[1].replace(/-/g,''))
                    } else{
                        list[i].begintime = 0
                        list[i].endtime = 0
                    }
                }
                this.occupancyForm.panelstatus = 0
                this.$emit('submitForm',this.occupancyForm,'5')
            } else {
                return false;
            }
        });
    }
    // reset
    private  resetForm(formName:string) {
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.occupancyForm.listList.forEach((item:any,index:any) => {
            if(item.id == 0){
                this.occupancyForm.listList.splice(index,1)
            }
        });
        this.$emit('resetForm','5')
    }

    // show add
    private addInfo () {
        this.$emit('addForm','5')
    }

    // edit
    private editInfo () {
        //点击编辑再赋值
        this.occupancyForm = JSON.parse(JSON.stringify(this.detailInfo.occupancy))
        this.$emit('editForm','5')
    }

    private handleRemove(file:any, fileList:any) {
    }

    private handlePreview(file:any) {
    }

    // 工作经历点添加
    private addExpri () {
        let list = JSON.parse(JSON.stringify(this.occupancyForm.listList))
        // return
        if(list.length > 0){
            let num:any = 0
            for(let i = 0 ; i < list.length ; i++){
                if(list[i].panelstatus == 0){
                    if(list[i].company == '' || list[i].position == '' || list[i].companyTime == ''){
                        num++ 
                    }
                }
            }
            if(num == 0){
                this.occupancyForm.listList.push({
                    id:0,
                    company:'',
                    position:'',
                    companyTime:[],
                    begintime:0,
                    endtime:'',
                    panelstatus:0
                })
            }

        }else{
            this.occupancyForm.listList.push({
                id:0,
                company:'',
                position:'',
                companyTime:[],
                begintime:0,
                endtime:'',
                panelstatus:0
            })
        }
        
    }

    private deleteOccupany (index:any){
        let list = this.occupancyForm.listList
        // 点击删除则直接把状态置为1，如果是新增，服务端会自动删除掉该条数据
        list[index].panelstatus = 1
        this.$forceUpdate()
    }

    private deleteInfo () {
        //弹框提示是否删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','5')
    }
}
